import { Language } from "../types";

export const languages: Language[] = [
  { code: "Russian", name: "Russian", iso: "ru" },
  { code: "English", name: "English", iso: "en" },
  { code: "Spanish", name: "Spanish", iso: "es" },
  { code: "French", name: "French", iso: "fr" },
  { code: "German", name: "German", iso: "de" },
  { code: "Italian", name: "Italian", iso: "it" },
  { code: "Portuguese", name: "Portuguese", iso: "pt" },
  { code: "Chinese", name: "Chinese", iso: "zh" },
  { code: "Japanese", name: "Japanese", iso: "ja" },
  { code: "Korean", name: "Korean", iso: "ko" },
  { code: "Arabic", name: "Arabic", iso: "ar" },
  { code: "Hindi", name: "Hindi", iso: "hi" },
  { code: "Urdu", name: "Urdu", iso: "ur" },
  { code: "Swahili", name: "Swahili", iso: "sw" },
  { code: "Turkish", name: "Turkish", iso: "tr" },
  { code: "Dutch", name: "Dutch", iso: "nl" },
  { code: "Swedish", name: "Swedish", iso: "sv" },
  { code: "Danish", name: "Danish", iso: "da" },
  { code: "Norwegian", name: "Norwegian", iso: "no" },
  { code: "Finnish", name: "Finnish", iso: "fi" },
  { code: "Greek", name: "Greek", iso: "el" },
  { code: "Polish", name: "Polish", iso: "pl" },
  { code: "Czech", name: "Czech", iso: "cs" },
  { code: "Hungarian", name: "Hungarian", iso: "hu" },
  { code: "Thai", name: "Thai", iso: "th" },
  { code: "Vietnamese", name: "Vietnamese", iso: "vi" },
  { code: "Filipino", name: "Filipino", iso: "tl" },
  { code: "Hebrew", name: "Hebrew", iso: "he" },
  { code: "Malay", name: "Malay", iso: "ms" },
  { code: "Tamil", name: "Tamil", iso: "ta" },
  { code: "Kannada", name: "Kannada", iso: "kn" },
  { code: "Marathi", name: "Marathi", iso: "mr" },
  { code: "Indonesian", name: "Indonesian", iso: "id" },
  { code: "Ukrainian", name: "Ukrainian", iso: "uk" },
  { code: "Romanian", name: "Romanian", iso: "ro" },
  { code: "Serbian", name: "Serbian", iso: "sr" },
  { code: "Croatian", name: "Croatian", iso: "hr" },
  { code: "Bulgarian", name: "Bulgarian", iso: "bg" },
  { code: "Belarusian", name: "Belarusian", iso: "be" },
];
